import { render, staticRenderFns } from "./header.vue?vue&type=template&id=0a96879b&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=0a96879b&prod&scoped=true&lang=scss"
import style1 from "./header.vue?vue&type=style&index=1&id=0a96879b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a96879b",
  null
  
)

export default component.exports